import { colorNeutralForegroundInverted, colorNeutralStroke1, display, strokeWidthThin } from "@fluentui/web-components";
import { css } from "@microsoft/fast-element";
/** Menu styles
 * @public
 */
export const styles = css `
  ${display("inline-block")}

  ::slotted([slot='trigger']) {
    anchor-name: --menu-trigger;
  }

  ::slotted([popover]) {
    inset-area: block-end span-inline-end;
    margin: 0;
    max-height: var(--menu-max-height, auto);
    overflow-y: auto;
    position-anchor: --menu-trigger;
    position-area: var(--menu-position-area, block-end span-inline-end);
    position-try-options: flip-block;
    position-try-fallbacks: flip-inline;
    position: absolute;
    z-index: 1;
  }

  :host([split]) ::slotted([popover]) {
    position-area: block-end span-inline-start;
  }

  ::slotted([popover]:popover-open) {
    inset: unset;
  }

  ::slotted([popover]:not(:popover-open)) {
    display: none;
  }

  /* Split button styles */
  :host([split]) {
    display: inline-flex;
  }

  :host([split]) ::slotted([slot="primary-action"]) {
    border-inline-end: ${strokeWidthThin} solid ${colorNeutralStroke1};
    border-start-end-radius: 0;
    border-end-end-radius: 0;
    z-index: 1;
  }

  /* Keeps focus visible visuals above trigger slot */
  :host([split]) ::slotted([slot="primary-action"]:focus-visible) {
    z-index: 1;
  }

  :host([split]) ::slotted([slot="primary-action"][appearance="primary"]) {
    border-inline-end: ${strokeWidthThin} solid
      ${colorNeutralForegroundInverted};
  }

  :host([split]) ::slotted([slot="trigger"]) {
    border-inline-start: 0;
    border-start-start-radius: 0;
    border-end-start-radius: 0;
  }
`;
//# sourceMappingURL=menu.styles.js.map